<template>
  <div :class="['app', colorClass]" :key="locale" style="width: 100vw">
    <new-project ref="newProject" v-on:projectcreated="openProject"></new-project>
    <locale-settings ref="localeSettings" :img-path="imgPath"></locale-settings>
    <file-viewer ref="viewer"></file-viewer>
    <alert
      ref="alert"
      :is-hidden="alert.isHidden"
      :is-open="alert.isOpen"
      :title="alert.title"
      :text="alert.text"
      :color="alert.style"
      :icon="alert.icon"
      v-on:dismiss="closeAlert"
      notification="bottom right"
      dismissable
    ></alert>
    <sidebar
      v-if="userLoggedIn"
      ref="sidebar"
      :logo-url="logoSideMenuUrl"
      :page-title="pageTitle"
      :menu="sideMenu"
      :current-view="currentView"
      :current-view-param="viewIndex"
      :is-active="sidebarOpen"
    ></sidebar>
    <div :class="['app-container', viewClass, containerClass, {'__sidebar': sidebarOpen, '__navbar': navbarOpen, 'app-full': fullView}]">
      <navbar
        v-if="userLoggedIn"
        :img-path="imgPath"
        :logo-url="logoNavbarUrl"
        :page-title="pageTitle"
        :title="viewTitle"
        :current-view="currentView"
        :current-user="currentUser"
        :is-active="navbarOpen"
        :message-count="messageCount"
        :messages="messages"
        :order-count="orderCount"
        :orders="orders"
        :project-count="projectCount"
        :projects="projects"
        :btn-back="btnBack"
        :hide-lists="hideHeaderLists"
      ></navbar>
      <component :is="currentView" :key="currentViewKey" :locale="$i18n.locale"></component>
    </div>
    <cookie-notification>
      <template slot="header-right-block">
        <short-lang-picker style="color: white;" id="cookie-locale-picker" class="form-control" @changeLocale="v => applyLanguage(v)"/>
      </template>
    </cookie-notification>
  </div>
</template>
<script>
import NewProject from './Views/NewProject.vue';
import FileViewer from './Views/FileViewer'
import Sidebar from './Elements/Sidebar.vue';
import Navbar from './Elements/Navbar.vue';

import ViewLocaleSettings from './Views/LocaleSettings.vue';
import ViewAddresses from './Views/Addresses.vue';
import ViewMessages from './Views/Messages.vue';
import ViewInfothek from './Views/Infothek.vue';
import ViewPage from './Views/Page.vue';
import ViewOrders from './Views/Orders.vue';
import ViewOrderDetails from './Views/OrderDetails.vue';
import ViewPackages from './Views/Packages.vue';
import ViewProjects from './Views/Projects.vue';
import ViewProjectDetails from './Views/ProjectDetails.vue';
import ViewDashboard from './Views/Dashboard.vue';
import ViewLogin from './Views/Login.vue';
import ViewLoader from './Views/Loader.vue';
import ViewUserSettings from './Views/UserSettings.vue';
import ViewInvoices from './Views/Invoices.vue';

import CookieNotification from './CookieConsent/CookieNotification';

import ShortLangPicker from './Elements/ShortLangPicker.vue';

var Routes = {
  'Addresses': null,
  'Messages': null,
  'Orders': null,
  'OrderDetails': null,
  'Packages': null,
  'Projects': null,
  'ProjectDetails': null,
  'Dashboard': null,
  'Login': null,
  'Forget': null,
  'UserSettings': null,
  'Invoices': null,
  'Infothek': null,
  'Page': null,
  // Sample Subview: 'View': ['Subview1', 'Subview2']
};

var view = require('./view.js'),
    viewData = {
      loaderComplete: false,
      containerClass: '',
      view: 'Dashboard',
      viewParam: null,
      currentUser: {},
      pageTitle: '',
      viewTitle: '',
      viewIndex: null,
      viewOptions: {},
      fullView: false,
      messageCount: 0,
      messages: [],
      projectCount: 0,
      projects: [],
      orderCount: 0,
      orders: [],
      alert: {
        isOpen: false,
        isHidden: true,
        title: '',
        text: '',
        style: '',
        icon: ''
      },
      btnBack: null,
      // locale: null,
    };

export default view(viewData, {
  components: {
    ShortLangPicker,
    CookieNotification,
    // Dialogs
    NewProject,
    FileViewer,
    // Menus
    'sidebar': Sidebar,
    'navbar': Navbar,
    // Views
    'LocaleSettings': ViewLocaleSettings,
    'Addresses': ViewAddresses,
    'Messages': ViewMessages,
    'Orders': ViewOrders,
    'OrderDetails': ViewOrderDetails,
    'Packages': ViewPackages,
    'Projects': ViewProjects,
    'ProjectDetails': ViewProjectDetails,
    'Dashboard': ViewDashboard,
    'Loader': ViewLoader,
    'Login': ViewLogin,
    'UserSettings': ViewUserSettings,
    'Invoices': ViewInvoices,
    'Infothek': ViewInfothek,
    'Page':ViewPage,
  },
  props: {
    sidebarOpen: {
      type: Boolean,
      default: false
    },
    navbarOpen: {
      type: Boolean,
      default: false
    },
    imgPath: {
      type: String
    },
    useLocale: {
      type: String
    }
  },
  watch: {
    locale: function (newLocale) {
      this.updateHeadLang(newLocale);
    }
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
    userLoggedIn() {
      return this.currentUser.ID != null;
    },
    currentViewKey() {
      return `${this.currentView}-${this.viewIndex}-${this.viewParam}`;
    },
    currentView() {
      if (this.view === 'Login' && this.userLoggedIn) {
        return this.$root.defaultView || 'Dashboard';
      }

      if (this.userLoggedIn) {
        return this.view;
      }

      return this.loaderComplete ? 'Login' : 'Loader';
    },
    colorClass() {
      return 'app-' + this.$parent.colorSchema;
    },
    viewClass() {
      return 'app-' + this.currentView.toLowerCase();
    },
    sideMenu() {
      return this.$parent.sideMenu;
    },
    routes() {
      return this.$parent.routes;
    },
    url() {
      return this.$parent.url;
    },
    urlPath() {
      return this.$parent.urlPath;
    },
    logoSideMenuUrl() {
      let url = this.getLogoUrl('logoSideMenu');
      return url === null ? this.getLogoUrl('logo') : url; // Fallback
    },
    logoNavbarUrl() {
      let url = this.getLogoUrl('logoNavbar');
      return url === null ? this.getLogoUrl('logo') : url; // Fallback
    },
    logoLoginUrl() {
      let url = this.getLogoUrl('logoLogin');
      return url === null ? this.getLogoUrl('logo') : url; // Fallback
    },
    hideHeaderLists() {
      return this.$root.isTrue('disableHeaderNofications');
    }
  },
  mounted() {
    // Get the locale from cookie
    if (this.$cookie.get('locale') != null && this.$i18n.messages.hasOwnProperty(this.$cookie.get('locale'))) {
      this.$i18n.locale = this.$cookie.get('locale');
    }

    if (this.$root.hasOwnProperty('defaultView'))
      this.view = this.$root.defaultView;

    this.resolveRoute(window.location.pathname);

    if (typeof history.pushState === "function") {
      window.onpopstate = function (evt) {
        this.resolveRoute(window.location.pathname);
      }.bind(this);
    }

    if (this.useLocale) {
      this.applyLanguage(this.useLocale);
    }

    this.updateHeadLang();
  },
  methods: {
    getUser() {
      return this.currentUser;
    },
    getProductFilters() {
      if (this.currentUser == null || (typeof this.currentUser.hide == 'undefined')) {
        return [];
      }

      return this.currentUser.hide;
    },
    getLogoUrl(logo) {
      if (!this.$parent.hasOwnProperty(logo))
        return null;

      return this.getImgUrl(this.$parent[logo]);
    },
    getImgUrl(img) {
      return img;
    },
    login() {
      this.$http.get(this.url + 'auth/').then(function(res) {
        if (res.data.result != null) {
          this.setUser(res.data.result);
        }
        this.loaderComplete = true;
      }.bind(this),
      function(res) {
        this.loaderComplete = true;
      }.bind(this));
    },
    setUser(user) {
      this.currentUser = user;
      if (this.currentUser != null && (typeof this.currentUser.image == 'undefined' || this.currentUser.image == null)) {
        this.currentUser.image = 'https://www.gravatar.com/avatar/00000000000000000000000000000000?d=mm&f=y';
      }
      this.currentUser.fullname = (this.currentUser.firstname == '' ? '' : this.currentUser.firstname + ' ') + this.currentUser.lastname;

      if (typeof gtag != 'undefined') {
        gtag('set', {'content_group2': this.currentUser.fullname + ' (' + this.currentUser.customernum + ')'});
      }

      // Add Raven Context
      this.$root.sentry(function(Raven) {
        Raven.setUserContext({
          email: user.email,
          id: user.ID,
          customernum: user.customernum,
          lastname: user.lastname,
          firstname: user.firstname
        });
      }.bind(this));

      this.refreshHeader();
    },
    refreshHeader() {
      if (this.hideHeaderLists)
        return;

      if (!this.currentUser || !this.currentUser.ID) {
        return ;
      }

      this.listOrders();
      this.listProjects();
      setTimeout(this.refreshHeader, 120000); // Refresh Header every 120 seconds
    },
    logout() {
      this.$http.delete(this.url + 'auth/').then(function(res) {
        this.currentUser = {};
        this.updateUrl('Login');

        this.$root.sentry(function(Raven) {
          Raven.setUserContext();
        }.bind(this));
      }.bind(this));
    },
    openLocaleSettings() {
      this.$refs.localeSettings.openDialog();
    },
    viewRoute(view) {
      return view.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
    },
    resolveRoute(pathname) {
      pathname = decodeURIComponent(pathname);

      if (pathname && pathname.startsWith('#')) {
        for(let {url, index, param, slug} of this.sideMenu) {
          if (pathname === '#' + slug) {
            this.openView(url, index, param);
            return;
          }
        }

        pathname = '';
      }

      if ((pathname === '' || pathname === '/') && this.sideMenu.length) {
        const [{url, index, param}] = this.sideMenu;
        this.openView(url, index, param);
        return;
      }

      var view, routeReg, routeMatch;
      this.viewIndex = null;
      this.viewParam = null;

      for (var view in Routes) {
        if (Routes.hasOwnProperty(view)) {
          routeReg = new RegExp('^' + this.urlPath + this.viewRoute(view) + '(/([^/]+))?(/([^/]+))?');
          //console.log('routeReg', routeReg.toString());
          routeMatch = pathname.match(routeReg);
          if (routeMatch) {

            let viewIndex = typeof routeMatch[2] == 'undefined' ? null : routeMatch[2];
            let viewParam = typeof routeMatch[4] == 'undefined' ? null : routeMatch[4];

            this.openView(view, viewIndex, viewParam);
            return;
          }
        }
      }
    },
    openView(view, index, param, options) {
      // Update the URL
      if (typeof index == 'string' || typeof index == 'number') {
        this.viewIndex = index;
      } else {
        this.viewIndex = null;
      }

      // Special rule for the "NewProject" dialog
      if (view === 'NewProject') {
        this.$refs.newProject.openDialog();
        return;
      }

      // An additional param (e.g. /project/1212/cart) can either open a subview (if the Routes value is an array)
      if (typeof param == 'string') {
        if (Array.isArray(Routes[view]) && Routes[view].indexOf(param) > -1) {
          view = param; // Use the sub view
        } else {
          this.viewParam = param;
        }
      } else {
        this.viewParam = null;
      }

      this.fullView = false;
      this.btnBack = null;

      this.view = view;

      this.$forceUpdate();

      if (typeof options == 'object') {
        this.viewOptions = options;
      } else {
        this.viewOptions = {};
      }

      this.updateUrl(view, index, param);
    },
    openProject(ID) {
      this.openView('ProjectDetails', ID);
    },
    openOrder(ID, previousView) {
      this.openView('OrderDetails', ID, previousView);
    },
    getUrl(view, index, param) {
      // Update the URL
      var url = this.urlPath + this.viewRoute(view);
      if (typeof index == 'string' || typeof index == 'number') {
        url = url + '/' + index;
      }
      if (typeof param == 'string') {
        url = url + '/' + this.viewRoute(param);
      }

      return url;
    },
    updateUrl(view, index, param) {
      window.history.pushState('', view, this.getUrl(view, index, param) + window.location.hash);
      setTimeout(() => window['ga']('send', 'pageview', window.location.pathname), 1);
    },
    setPrevious(view, index, param) {
      if (typeof view == 'function') {
        this.btnBack = view;
        return;
      }
      this.btnBack = function() {
        this.openView(view, index, param);
      }.bind(this);
    },
    listOrders() {
      this.$http.get(this.$root.url + 'order/', {params: {limit: 5}}).then(function(res) {
          viewData.orderCount = res.data.result.count;
          viewData.orders = [];
          res.data.result.data.forEach(function(item) {
            viewData.orders.push({
              onclick: function() {
                this.openView('OrderDetails', item.ID);
              }.bind(this),
              title: item.transactionnum,
              // count: _s.numberFormat(parseFloat(item.netamount), 2, ',', '.') + ' €'
              order: item,
              description: (new Date(item.date * 1000)).toLocaleDateString()
            });
          }.bind(this));
        }.bind(this),
        function(res) {
          if (typeof res.code != 'undefined' && res.code === 401) {
            return;
          }

          this.alertDanger('Bestellungen konnten nicht geladen werden');
          console.log(res);
        }.bind(this));
    },
    listProjects() {
      this.$http.get(this.$root.url + 'project/', {params: {limit: 5}}).then(function(res) {
          viewData.projectCount = res.data.result.count;
          viewData.projects = [];
          res.data.result.data.forEach(function(item) {
            viewData.projects.push({
              onclick: function() {
                this.openView('ProjectDetails', item.ID);
              }.bind(this),
              title: item.name,
              // count: _s.numberFormat(parseFloat(item.netamount), 2, ',', '.') + ' €'
              status: item.status,
              description: (new Date(item.creationdate * 1000)).toLocaleDateString()
            });
          }.bind(this));
        }.bind(this),
        function(res) {
          if (typeof res.code != 'undefined' && res.code === 401) {
            return;
          }

          this.alertDanger('Projekte konnten nicht geladen werden');
          console.log(res);
        }.bind(this));
    },
    closeAlert() {
      this.$refs.alert.close(viewData.alert);
    },
    showAlert(title, text, icon, style, timeout) {
      viewData.alert.icon  = icon;
      viewData.alert.style = style;
      viewData.alert.title = title;
      viewData.alert.text  = text;
      this.$refs.alert.open(viewData.alert, typeof timeout == 'undefined' ? 3000 : timeout);
    },
    alertRemoved(title, text) {
      this.showAlert(title, text, 'trash', 'danger');
    },
    alertSuccess(title, text, timeout) {
      this.showAlert(title, text, 'check-circle', 'success');
    },
    alertDanger(title, text, timeout) {
      this.showAlert(title, text, 'exclamation-triangle', 'danger');
    },
    alertInfo(title, text, timeout) {
      this.showAlert(title, text, 'info-circle', 'info');
    },
    applyLanguage(locale) {
      this.$i18n.locale = locale;
      this.$cookie.set('locale', locale, 365);
      this.$forceUpdate();

      this.$root.footer && setTimeout(() => {
        document.querySelector('footer-container').innerHTML = this.$t(this.$root.footer);
      }, 10);
    },
    resetMessagesCounter() {
      this.$refs.sidebar.resetMessagesCounter()
    },
    openPreviewDialog(url, filename, downloadable) {
      this.$refs.viewer.openDialog(url, filename, downloadable);
    },
    updateHeadLang() {
      document.documentElement.lang = this.locale;
    }
  }
});
</script>
